import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'simple-header',
  templateUrl: 'simple-header.component.html',
  styleUrls: ['simple-header.scss'],
})
export class SimpleHeaderComponent {

  constructor() {

  }



}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/shared/simple-header/simple-header.component.ts